import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Icon, VisuallyHidden } from '@zapier/design-system';
import { interactiveReset } from '../../../../utils/style-mixins/reset';
const Styles = labelStyles('SearchTogglerInApp', {
    root: (size) => css `
    ${interactiveReset};
    height: 36px;
    border-radius: var(--zds-radius-small, 3px);
    display: flex;
    align-items: center;
    gap: var(--zds-space-4, 4px);
    padding: ${size === 'medium'
        ? ' 10px var(--zds-space-12, 12px)'
        : '10px var(--zds-space-4, 4px)'};
    justify-content: center;
    color: var(--zds-text-default, #413735);
    font-weight: 500;

    &:hover,
    &:focus {
      color: var(--zds-text-default, #413735);
      background-color: var(--zds-background-stronger, #f5f3eb);
    }
  `,
});
const SearchToggler = (props) => {
    return (jsx("label", { css: Styles.root(props.size), htmlFor: props.id, "data-zds": true },
        jsx(Icon, { name: props.isSearching ? 'formX' : 'navSearch', size: 24 }),
        props.size !== 'small' ? ('Search') : (jsx(VisuallyHidden, null, "Search"))));
};
export default SearchToggler;
//# sourceMappingURL=SearchToggler.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
